import React, { Component } from 'react';
import CSSModules from 'helpers/CSSModulesUtil';
import styles from './styles.scss';
import { compose } from 'recompose';
import ThermalTest from './ThermalTest'
import ThermalTestEnterpriseGpu from './ThermalTestEnterpriseGpu'
import ThermalTestEnterpriseCpu from './ThermalTestEnterpriseCpu'
import PexQualTest from './PexQualTest'
import PexBandwidthTest from './PexBandwidthTest'
import PexPeerToPeerTest from './PexPeerToPeerTest'
import InputEdpPeakTest from './InputEdpPeakTest'
import NvlinkBandwidthTest from './NvlinkBandwidthTest'
import PexDataEyeTest from './PexDataEyeTest'
import NvlinkDataEyeTest from './NvlinkDataEyeTest'
import NvlinkQualTest from './NvlinkQualTest'
import NvlinkQualTestEnterprise from './NvlinkQualTestEnterprise'
import { CUSTOMER_INPUTS } from 'containers/NvqualReport/constants'
import { Element } from 'react-scroll'
import { NVQUAL_TESTS, ENTERPRISE_NVQUAL_VERSION_PREFIX } from 'containers/NvqualReport/constants'
import GenericTestSection from './GenericTestSection';

class AggregateTestReports extends Component {
  isEnterpriseNvQualVersion() {
    const nvqualPackageVersion = _.get(this.props, 'currentRevision.revision.data.nvqualPackageVersion', '')
    return nvqualPackageVersion.indexOf(ENTERPRISE_NVQUAL_VERSION_PREFIX) == 0;
  }

  renderTestSection(testId, props) {
    const { customerInputs } = this.props.currentRevision.revision
    const thermalCustomerCheck = customerInputs
      && Object.keys(customerInputs).filter(x => CUSTOMER_INPUTS.thermal_qual_test.includes(x)).length > 0
    const edpCustomerCheck = customerInputs
      && Object.keys(customerInputs).filter(x => CUSTOMER_INPUTS.input_edp_test.includes(x)).length > 0

    const componentProps = { ...props, testId };

    switch (testId) {
      case 'thermal_qual_test':
        return this.isEnterpriseNvQualVersion() ?
          <ThermalTestEnterpriseGpu {...componentProps} /> :
          <ThermalTest {...componentProps} customerInputs={thermalCustomerCheck ? customerInputs : null} />;
      case 'thermal_qual_test_cpu':
        return <ThermalTestEnterpriseCpu  {...componentProps} />;
      case 'pcie_qual_test':
        return <PexQualTest {...componentProps} />;
      case 'pcie_bandwidth_test':
        return <PexBandwidthTest {...componentProps} />;
      case 'pcie_peer_to_peer_test':
        return <PexPeerToPeerTest {...componentProps} />;
      case 'input_edp_test':
        return this.isEnterpriseNvQualVersion() ?
        <GenericTestSection {...componentProps} />:
        <InputEdpPeakTest {...componentProps} customerInputs={edpCustomerCheck ? customerInputs : null} />;
      case 'nvlink_bandwidth_test':
        return <NvlinkBandwidthTest {...componentProps} />;
      case 'nvlink_qual_test':
        return this.isEnterpriseNvQualVersion() ? <NvlinkQualTestEnterprise {...componentProps} /> : <NvlinkQualTest {...componentProps} />;
      case 'nvlink_data_eye_test':
        return <NvlinkDataEyeTest {...componentProps} />;
      case 'pcie_data_eye_test':
        return <PexDataEyeTest {...componentProps} />;
      default:
        return <GenericTestSection {...componentProps} />;
    }
  }

  render() {
    const { tests } = this.props.currentRevision

    return (
      <React.Fragment>
        {NVQUAL_TESTS.map(testId => {
          const testProps = tests.find(x => x.testName === testId);
          return (
            (testProps && testProps.result != "Skipped" && <Element key={testId} name={testId}>
              {this.renderTestSection(testId, testProps)}
            </Element>)
          );
        })}
      </React.Fragment>
    );
  }
}

const withStyles = CSSModules(styles);
const enhance = compose(withStyles);
export default enhance(AggregateTestReports);
